module.exports = __webpack_public_path__ + "static/media/shopping_boatramp_marker.225dd3d3.svg";